import { Dashboard } from '@dtk/dashboard';

const DashboardPage = () => {
  return <Dashboard />;
};

export default DashboardPage;
